var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { BoldIconGlyph, Heading1IconGlyph, Heading2IconGlyph, Heading3IconGlyph, Heading4IconGlyph, TextIconGlyph } from '@shapeable/icons';
import { useComponentProps } from '../context/component-props-context';
import { OptionMenuInput } from '../select';
import { usePages } from '../hooks/use-pages';
import { EntityTypeSelect } from '../select/entity-type-select';
var cls = classNames('ExampleMenus');
export var ExampleMenusDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var OptionMenuButtonStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: ", ";\n    align-self: flex-start;\n  "], ["\n    margin: ", ";\n    align-self: flex-start;\n  "])), theme.UNIT(2))
});
var OptionMenuInputStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 600px;\n    margin: ", ";\n  "], ["\n    max-width: 600px;\n    margin: ", ";\n  "])), theme.UNIT(2))
});
var EntityTypeSelectStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: 600px;\n    margin: ", ";\n    \n  "], ["\n    max-width: 600px;\n    margin: ", ";\n    \n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  NAME: 'ExampleMenus',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  OptionMenuInput: styled(OptionMenuInput)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), OptionMenuInputStyles),
  OptionMenuButton: styled(OptionMenuInput)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), OptionMenuButtonStyles),
  EntityTypeSelect: styled(EntityTypeSelect)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), EntityTypeSelectStyles)
};
export var ExampleMenus = function (props) {
  var componentProps = useComponentProps(My.NAME, ExampleMenusDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children;
  var menu = {
    id: 'main',
    sections: [{
      id: 'suggested',
      name: 'Suggested'
    }, {
      id: 'basic',
      name: 'Basic'
    }],
    items: [{
      id: 'text',
      label: 'Text',
      section: 'suggested',
      iconComponent: TextIconGlyph
    }, {
      id: 'h1',
      label: 'Heading 1',
      section: 'suggested',
      iconComponent: Heading1IconGlyph
    }, {
      id: 'h1',
      label: 'Heading 1',
      section: 'basic',
      iconComponent: Heading1IconGlyph
    }, {
      id: 'h2',
      label: 'Heading 2',
      section: 'basic',
      iconComponent: Heading2IconGlyph
    }, {
      id: 'h3',
      label: 'Heading 3',
      section: 'basic',
      iconComponent: Heading3IconGlyph
    }, {
      id: 'h4',
      label: 'Heading 4',
      section: 'basic',
      iconComponent: Heading4IconGlyph
    }, {
      id: 'bold',
      label: 'Bold',
      section: 'basic',
      iconComponent: BoldIconGlyph
    }, {
      id: 'text',
      label: 'Text',
      section: 'basic',
      iconComponent: TextIconGlyph
    }]
  };
  var organisations = usePages();
  var entityMenu = {
    id: 'organisations',
    sections: [{
      id: 'suggested',
      name: 'Suggested'
    }, {
      id: 'all',
      name: 'All Pages'
    }],
    items: __spreadArray(__spreadArray([], __read(organisations.slice(0, 5).map(function (item) {
      return {
        id: item.id,
        label: item.name,
        section: 'suggested',
        data: {
          entity: item
        }
      };
    })), false), __read(organisations.map(function (item) {
      return {
        id: item.id,
        label: item.name,
        section: 'all',
        data: {
          entity: item
        }
      };
    })), false)
  };
  var _a = __read(React.useState(menu.items[0]), 2),
    value1 = _a[0],
    setValue1 = _a[1];
  var _b = __read(React.useState(entityMenu.items[0]), 2),
    value2 = _b[0],
    setValue2 = _b[1];
  var _c = __read(React.useState(), 2),
    value3 = _c[0],
    setValue3 = _c[1];
  var _d = __read(React.useState(), 2),
    value4 = _d[0],
    setValue4 = _d[1];
  var _e = __read(React.useState(), 2),
    value5 = _e[0],
    setValue5 = _e[1];
  var _f = __read(React.useState(), 2),
    value6 = _f[0],
    setValue6 = _f[1];
  var _g = __read(React.useState(''), 2),
    inputValue6 = _g[0],
    setInputValue6 = _g[1];
  var _h = __read(React.useState(), 2),
    entityValue = _h[0],
    setEntityValue = _h[1];
  console.log("ENTITY VALUE", entityValue);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.EntityTypeSelect, {
    entityTypeName: "Page",
    allowMultipleSelections: true,
    // usePortal
    selectedItems: entityValue,
    onSelect: function (_a) {
      var items = _a.items;
      setEntityValue(items);
    }
  }));
};
ExampleMenus.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;